module.exports = __webpack_public_path__ + "img/Nicholas Venn Springfield College.10d411b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/Nicholas Venn Springfield College.jpg
// module id = 1167
// module chunks = 1